module.exports = __webpack_public_path__ + "img/nose_male_wide.a8aabfc8.png";